import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/recommend-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-62a4221c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "chr-quickwins" }
const _hoisted_2 = {
  id: "printTitleAndDescription",
  class: "tw-flex tw-items-start tw-self-stretch"
}
const _hoisted_3 = { class: "tw-flex tw-flex-col tw-justify-between tw-gap-[12px] tw-pb-[40px] tw-w-[100%] tw-break-inside-avoid" }
const _hoisted_4 = { class: "tw-w-[100%]" }
const _hoisted_5 = {
  id: "chr-sheading-quickwins",
  class: "tw-text-[#211F58] tw-text-[24px] tw-font-semibold tw-w-fit"
}
const _hoisted_6 = { class: "tw-text-[#231F20] tw-text-[14px] tw-font-normal lg:tw-w-[50%] tw-opacity-[0.7]" }
const _hoisted_7 = { class: "tw-text-[#387DFF] tw-text-[14px] tw-font-normal" }
const _hoisted_8 = {
  key: 0,
  class: "tw-h-[44px] tw-mr-[20px] tw-relative tw-flex tw-items-center tw-flex-wrap"
}
const _hoisted_9 = {
  key: 0,
  class: "quickwin-table tw-overflow-auto"
}
const _hoisted_10 = {
  key: 0,
  id: "recommendPdfParent",
  class: "tw-flex tw-flex-col tw-rounded-[6px] tw-w-[1500px] tw-gap-[20px]"
}
const _hoisted_11 = { class: "tw-flex tw-justify-center tw-items-center tw-w-[160px] tw-min-w-[160px] tw-h-[111px] tw-mr-[32px] tw-bg-[#d9edff] tw-rounded-[6px]" }
const _hoisted_12 = {
  key: 0,
  src: _imports_0
}
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  id: "recommendPdf",
  class: /*#__PURE__*/_normalizeClass(`tw-w-full tw-flex tw-flex-row tw-justify-between`)
}
const _hoisted_15 = {
  class: /*#__PURE__*/_normalizeClass(`tw-flex tw-gap-[12px] tw-w-[358px] tw-flex-col`),
  style: {"overflow-wrap":"anywhere"}
}
const _hoisted_16 = { class: "tw-flex tw-justify-between tw-items-start tw-text-[20px] tw-text-[#211F58] tw-font-semibold" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  key: 1,
  class: "tw-flex tw-flex-col tw-w-full tw-relative tw-justify-start"
}
const _hoisted_19 = ["onUpdate:modelValue", "onFocus", "onInput", "onBlur"]
const _hoisted_20 = {
  key: 0,
  class: "tw-h-[35px] tw-w-[35px] tw-absolute tw-right-[12px]"
}
const _hoisted_21 = {
  key: 1,
  class: "tw-text-[#f7553c] tw-font-[500] tw-text-[11px] tw-leading-[130%] tw-mt-[3px]"
}
const _hoisted_22 = {
  key: 2,
  class: "tw-flex tw-items-center tw-pt-[4px] tw-ml-6"
}
const _hoisted_23 = {
  key: 0,
  class: "tw-text-[16px] tw-text-[#231F20] tw-font-normal tw-leading-[150%]"
}
const _hoisted_24 = {
  key: 1,
  class: "tw-relative tw-flex tw-items-start"
}
const _hoisted_25 = {
  key: 0,
  class: "tw-h-[35px] tw-w-[35px] tw-absolute tw-right-[12px]"
}
const _hoisted_26 = {
  class: /*#__PURE__*/_normalizeClass(`tw-flex tw-gap-[12px] tw-flex-col tw-w-[403px]`)
}
const _hoisted_27 = { class: "tw-text-[20px] tw-text-[#211F58] tw-font-semibold" }
const _hoisted_28 = {
  class: "tw-text-[14px] tw-text-[#231F20] tw-font-normal tw-leading-[150%]",
  style: {"overflow-wrap":"anywhere"}
}
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = {
  key: 1,
  class: "tw-relative tw-flex tw-items-start"
}
const _hoisted_31 = {
  key: 0,
  class: "tw-h-[35px] tw-w-[35px] tw-absolute tw-right-[12px]"
}
const _hoisted_32 = {
  class: /*#__PURE__*/_normalizeClass(`tw-flex tw-gap-[20px] tw-items-center`)
}
const _hoisted_33 = { class: "quality-group tw-h-[45px]" }
const _hoisted_34 = { class: "tw-text-[14px] tw-text-[#211F58] tw-font-semibold" }
const _hoisted_35 = { class: "quality-group tw-h-[45px]" }
const _hoisted_36 = { class: "tw-text-[14px] tw-text-[#211F58] tw-font-semibold" }
const _hoisted_37 = {
  key: 1,
  class: "tw-overflow-auto"
}
const _hoisted_38 = {
  id: "recommendPdfParent",
  class: "tw-flex tw-flex-col tw-rounded-[6px] tw-w-[1500px] tw-gap-[20px]"
}
const _hoisted_39 = {
  "data-cy": "quick-wins-empty-list",
  class: "tw-flex tw-p-[40px] tw-items-center tw-self-stretch recommend-item"
}
const _hoisted_40 = { class: "tw-h-[110px] tw-w-[100%] tw-flex tw-justify-center tw-items-center tw-text-[#878787] tw-text-[14px]" }
const _hoisted_41 = {
  key: 1,
  class: "tw-overflow-auto"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-flex-col tw-rounded-[6px] tw-w-[1500px] tw-gap-[20px]" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-p-[40px] tw-items-center tw-self-stretch recommend-item" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "custom-global-skeleton-pulse tw-h-[110px] tw-w-[100%] tw-rounded-[6px]" })
  ])
], -1))
const _hoisted_43 = [
  _hoisted_42
]

import TextInputWithArrow from "@/components/share/textInputWithArrow.vue";
import { getComponentUiText, parseDescription } from "@/utils/utilities";
import { computed, nextTick, ref, Ref, watch } from "vue";
import QualityAssessment from "./qualityAssessment.vue";
import router from "@/router";
import store from "@/store";
import AssessmentChecklistStatusTag from "@/components/assessment/assessmentChecklistStatusTag.vue";
import {
  CHECKLISTSTATUS,
  localStorageKey,
  QUALITY_ASSESSMENT_TYPE,
} from "@/utils/constants";
import Pen from "@/components/svgs/pen.vue";
import customDescriptionContent from "@/components/common/customDescriptionContent.vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { Checklist } from "@/services/apiRoutes/routes";
import { putChecklistGroup } from "@/services/recommend";
import { LottieAnimation } from "lottie-web-vue";
import ProgressAnimation from "@/assets/animation/progress_light.json";
import { exceptionStatusCodes } from "../../utils/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'quickWins',
  props: {
  isEdit: {
    type: Boolean,
    default: false,
  },
  isEnableEdit: {
    type: Boolean,
    default: true,
  },
  rootChecklistReportId: {
    type: Number,
    default: 0,
  },
},
  emits: [
  "update-hover-title",
  "on-update-input",
  "update-edit-title",
  "on-click-edit",
  "update:edit",
  "on-form-invalid",
],
  setup(__props, { emit }) {

const props = __props;


const itemInvalids: any = ref([]);
const checklistGroupNameRef = ref(null);
const checklistGroupDescriptionRef = ref(null);
const checklistGroupActionsRef = ref(null);
const isCallApi = ref(false);
const idUpdateItem = ref(0);
const isUpdateName = ref(false);
const isUpdateActions = ref(false);
const isUpdateDescription = ref(false);

const onresizeTextarea = (ref, index) => {
  nextTick(() => {
    if (!ref || !ref[index]) {
      return;
    }
    const textarea = ref[index];
    textarea.style.height = "auto";
    textarea.style.height = `${textarea.scrollHeight}px`;
  });
};

const handleArrowClick = ({ value }) => {
  paging.value = value;

  if (!props.rootChecklistReportId || props.rootChecklistReportId === 0) return;

  const localData = JSON.parse(
    localStorage.getItem(localStorageKey.sharingPagingQuickwin) || "{}",
  );

  localData[props.rootChecklistReportId] = value;

  localStorage.setItem(
    localStorageKey.sharingPagingQuickwin,
    JSON.stringify(localData),
  );
};

watch(
  () => props.isEdit,
  (newVal) => {
    if (newVal) {
      nextTick(() => {
        const checklistGroupNameRefs = checklistGroupNameRef.value;
        if (checklistGroupNameRefs && checklistGroupNameRefs.length) {
          checklistGroupNameRefs.forEach((ref, index) => {
            onresizeTextarea(checklistGroupNameRefs, index);
          });
        }
        const checklistGroupDescriptionRefs =
          checklistGroupDescriptionRef.value;
        if (
          checklistGroupDescriptionRefs &&
          checklistGroupDescriptionRefs.length
        ) {
          checklistGroupDescriptionRefs.forEach((ref, index) => {
            onresizeTextarea(checklistGroupDescriptionRefs, index);
          });
        }
        const checklistGroupActionsRefs = checklistGroupActionsRef.value;
        if (checklistGroupActionsRefs && checklistGroupActionsRefs.length) {
          checklistGroupActionsRefs.forEach((ref, index) => {
            onresizeTextarea(checklistGroupActionsRefs, index);
          });
        }
      });
    }
  },
);

const editNotes = () => {
  if (itemInvalids.value.length) {
    return;
  }
  emit("update:edit", !props.isEdit);
};
watch(
  () => itemInvalids.value,
  (newVal) => {
    if (itemInvalids.value.length) {
      emit("on-form-invalid", true);
    } else {
      emit("on-form-invalid", false);
    }
  },
  { deep: true },
);
const updateChecklistGroup = async (param, item) => {
  idUpdateItem.value = item.checklistGroupId;
  try {
    isCallApi.value = true;
    if (param.checklistGroupId) {
      const params = {
        checklistId: store.getters["Sharing/getChecklistReportId"],
        ...param,
      };
      const res = await putChecklistGroup(params);
      return res.data.data;
    }
  } catch (error) {
    const extendText = getComponentUiText(
      "app-share-cyber-profile-extend-error-messages-1",
      false,
      {
        name: getComponentUiText(
          "app-share-cyber-profile-display-option-quick-wins-1",
        ),
      },
    );
    showErrorAPI(
      error,
      Checklist.updateChecklistItemGroup,
      exceptionStatusCodes.BadGateway,
      extendText,
    );
    return null;
  } finally {
    setTimeout(() => {
      isCallApi.value = false;
      isUpdateName.value = false;
      isUpdateActions.value = false;
      isUpdateDescription.value = false;
    }, 1000);
  }
};

const maxPaging = computed(() => {
  const data = store.getters["Sharing/getChecklistQuickWin"];
  return data && data.length ? data.length : 0;
});

const paging: Ref<any> = ref(5);

const getPagingValue = () => {
  const localData = JSON.parse(
    localStorage.getItem(localStorageKey.sharingPagingQuickwin) || "{}",
  );

  if (!props.rootChecklistReportId || props.rootChecklistReportId === 0)
    return maxPaging.value;

  if (localData[props.rootChecklistReportId]) {
    const value = Number(localData[props.rootChecklistReportId]);
    return value > maxPaging.value ? maxPaging.value : value;
  }

  return maxPaging.value;
};

watch(
  () => maxPaging.value,
  (newVal) => {
    maxPaging.value && (paging.value = getPagingValue());
  },
);
const customTableData = computed(() => {
  const data = store.getters["Sharing/getChecklistQuickWin"];
  data &&
    data.length &&
    data.forEach((group) => {
      const { checklistGroupImage, checklistGroupDescription } =
        parseDescription(group);
      group.checklistGroupImage = checklistGroupImage;
      group.checklistGroupDescription = checklistGroupDescription;
      return group;
    });

  if (
    !data ||
    !data.length ||
    !paging.value ||
    typeof paging.value !== "number"
  )
    return [];

  return !paging.value ? data : data.slice(0, Number(paging.value) || 5);
});

const isLoading: Ref<any> = computed(() => {
  return store.state.Sharing.loadingSplit[
    Checklist.getChecklistReportDataActions
  ];
});

const openRecommendPage = () => {
  router.push("/assess/roadmap");
};

return (_ctx: any,_cache: any) => {
  const _component_Textarea = _resolveComponent("Textarea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(getComponentUiText)("app-share-cyber-profile-quick-wins-title-1")), 1)
        ]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(getComponentUiText)("app-share-cyber-profile-quick-wins-sub-title-1")), 1),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", {
            class: "tw-m-[0px] tw-cursor-pointer tw-w-fit",
            onClick: openRecommendPage
          }, _toDisplayString(_unref(getComponentUiText)(
                "app-share-cyber-profile-quick-wins-view-all-recommend-button-title-1",
              )), 1)
        ])
      ]),
      (customTableData.value?.length > 0 && __props.isEdit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(TextInputWithArrow, {
              max: maxPaging.value,
              paging: paging.value || maxPaging.value || 5,
              type: _unref(localStorageKey).sharingPagingQuickwin,
              "custom-input-class": 'tw-text-[14px]',
              onArrowClick: handleArrowClick
            }, null, 8, ["max", "paging", "type"])
          ]))
        : _createCommentVNode("", true),
      (__props.isEnableEdit)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            id: "pen-icon-incidents",
            class: _normalizeClass([__props.isEdit ? 'is_editable' : 'not_editable', "header__pen"]),
            onClick: editNotes
          }, [
            _createVNode(Pen, {
              color: __props.isEdit ? '#ffffff' : '#387DFF'
            }, null, 8, ["color"])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (customTableData.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customTableData.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    "data-cy": `quick-wins-list`,
                    class: _normalizeClass([{ 'first-item': index === 0 }, "tw-flex tw-p-[40px] tw-items-center tw-self-stretch recommend-item"])
                  }, [
                    _createElementVNode("div", _hoisted_11, [
                      (!item.checklistGroupImage)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: item.checklistGroupImage,
                            class: "tw-max-w-[96px]"
                          }, null, 8, _hoisted_13))
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          (!__props.isEdit)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "tw-flex-1",
                                innerHTML: 
                    `${item.index}. ${item.checklistGroupName?.replace(
                      /\n/g,
                      '<br>',
                    )}`
                  
                              }, null, 8, _hoisted_17))
                            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _withDirectives(_createElementVNode("textarea", {
                                  ref_for: true,
                                  ref_key: "checklistGroupNameRef",
                                  ref: checklistGroupNameRef,
                                  "onUpdate:modelValue": ($event: any) => ((item.checklistGroupName) = $event),
                                  class: _normalizeClass(`tw-bg-[#eff0f180] tw-p-[12px] ${
                      isCallApi.value &&
                      isUpdateName.value &&
                      idUpdateItem.value === item.checklistGroupId
                        ? 'tw-pr-[45px]'
                        : ''
                    } tw-text-[16px] tw-font-[400] tw-text-[#231F20] tw-overflow-hidden ${
                      itemInvalids.value.includes(item.checklistGroupId)
                        ? 'tw-border-[red] tw-outline-none '
                        : 'tw-border-[#EFF0F1]  tw-outline-[#EFF0F1]'
                    } tw-border-solid tw-border tw-rounded-md`),
                                  rows: "1",
                                  type: "text",
                                  onFocus: 
                      () => {
                        if (item.checklistGroupName)
                          item.oldName = item.checklistGroupName;
                      }
                    ,
                                  onInput: 
                      (e) => {
                        onresizeTextarea(checklistGroupNameRef.value, index);
                        const idxValid = itemInvalids.value.indexOf(
                          item.checklistGroupId,
                        );
                        if (e.target.value && idxValid !== -1) {
                          itemInvalids.value.splice(idxValid, 1);
                          item.checklistGroupName = e.target.value;
                        }
                      }
                    ,
                                  onBlur: 
                      async (e) => {
                        isUpdateName.value = true;
                        isUpdateActions.value = false;
                        isUpdateDescription.value = false;
                        const value = e.target.value.trim();
                        if (item.oldName === value || !value) {
                          if (!value) {
                            itemInvalids.value.push(item.checklistGroupId);
                            item.checklistGroupName = '';
                          }
                          return;
                        }
                        const idxValid = itemInvalids.value.indexOf(
                          item.checklistGroupId,
                        );
                        if (idxValid !== -1) {
                          itemInvalids.value.splice(idxValid, 1);
                        }
                        const res = await updateChecklistGroup(
                          {
                            checklistGroupId: item.checklistGroupId,
                            name: value,
                          },
                          item,
                        );
                        item.checklistGroupName = res ? res.name : item.oldName;
                      }
                    
                                }, null, 42, _hoisted_19), [
                                  [_vModelText, item.checklistGroupName]
                                ]),
                                (
                      isCallApi.value &&
                      isUpdateName.value &&
                      idUpdateItem.value === item.checklistGroupId
                    )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                      _createVNode(_unref(LottieAnimation), {
                                        ref_for: true,
                                        ref: "anim",
                                        "animation-data": _unref(ProgressAnimation),
                                        "auto-play": true,
                                        loop: true
                                      }, null, 8, ["animation-data"])
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                      __props.isEdit && itemInvalids.value.includes(item.checklistGroupId)
                    )
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(getComponentUiText)(
                        "app-common-form-value-required-error-1",
                      )), 1))
                                  : _createCommentVNode("", true)
                              ])),
                          (item.checklistGroupCompletionPcnt !== null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                (item.checklistGroupCompletionPcnt !== null)
                                  ? (_openBlock(), _createBlock(AssessmentChecklistStatusTag, {
                                      key: 0,
                                      class: "tw-flex-1",
                                      "checklist-status": 
                      item.checklistGroupCompletionPcnt === 1
                        ? _unref(getComponentUiText)(
                            'app-component-assessments-checklists-assessment-details-card-status-3',
                          )
                        : item.checklistGroupCompletionPcnt > 0 &&
                            item.checklistGroupCompletionPcnt < 1
                          ? _unref(getComponentUiText)(
                              'app-component-assessments-checklists-assessment-details-card-status-1',
                            )
                          : _unref(getComponentUiText)(
                              'app-component-assessments-checklists-assessment-details-card-status-2',
                            )
                    ,
                                      "checklist-status-id": 
                      item.checklistGroupCompletionPcnt === 1
                        ? _unref(CHECKLISTSTATUS).DONE
                        : item.checklistGroupCompletionPcnt > 0 &&
                            item.checklistGroupCompletionPcnt < 1
                          ? _unref(CHECKLISTSTATUS).INPROG
                          : _unref(CHECKLISTSTATUS).NEW
                    ,
                                      "is-loading": false
                                    }, null, 8, ["checklist-status", "checklist-status-id"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (item.checklistGroupDescription || __props.isEdit)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              (!__props.isEdit)
                                ? (_openBlock(), _createBlock(customDescriptionContent, {
                                    key: 0,
                                    description: 
                    item.checklistGroupDescription?.replace(/\n/g, '<br>')
                  ,
                                    "class-line": 'tw-text-base tw-font-normal tw-leading-6 tw-text-[#231F20]',
                                    "custom-class": '!tw-p-0'
                                  }, null, 8, ["description"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    _createVNode(_component_Textarea, {
                                      ref_for: true,
                                      ref_key: "checklistGroupDescriptionRef",
                                      ref: checklistGroupDescriptionRef,
                                      modelValue: item.checklistGroupDescription,
                                      "onUpdate:modelValue": ($event: any) => ((item.checklistGroupDescription) = $event),
                                      style: `outline-color : #EFF0F1`,
                                      value: item.checklistGroupDescription,
                                      class: _normalizeClass([`${
                      isCallApi.value &&
                      isUpdateDescription.value &&
                      idUpdateItem.value === item.checklistGroupId
                        ? 'tw-pr-[45px]'
                        : ''
                    }`, "tw-bg-[#eff0f180] tw-overflow-hidden tw-w-full tw-p-[12px] tw-text-[16px] tw-font-[400] tw-text-[#231F20] tw-border-[#EFF0F1] tw-border-solid tw-border tw-rounded-md"]),
                                      type: "text",
                                      rows: "1",
                                      onInput: ($event: any) => (
                      onresizeTextarea(checklistGroupDescriptionRef.value, index)
                    ),
                                      onFocus: 
                      () => {
                        if (item.checklistGroupDescription)
                          item.oldChecklistGroupDescription =
                            item.checklistGroupDescription;
                      }
                    ,
                                      onBlur: 
                      async (e) => {
                        isUpdateDescription.value = true;
                        isUpdateName.value = false;
                        isUpdateActions.value = false;

                        const value = e.target.value.trim();
                        if (item.oldChecklistGroupDescription === value) {
                          return;
                        }
                        item.checklistGroupDescription = value;
                        const res = await updateChecklistGroup(
                          {
                            checklistGroupId: item.checklistGroupId,
                            description: value,
                          },
                          item,
                        );
                        item.checklistGroupDescription = res
                          ? res.description
                          : item.oldChecklistGroupDescription;
                      }
                    
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "value", "class", "onInput", "onFocus", "onBlur"]),
                                    (
                      isCallApi.value &&
                      isUpdateDescription.value &&
                      idUpdateItem.value === item.checklistGroupId
                    )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                          _createVNode(_unref(LottieAnimation), {
                                            ref_for: true,
                                            ref: "anim",
                                            "animation-data": _unref(ProgressAnimation),
                                            "auto-play": true,
                                            loop: true
                                          }, null, 8, ["animation-data"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("span", null, _toDisplayString(_unref(getComponentUiText)(
                      "app-share-cyber-profile-quick-wins-how-header-title-1",
                    )), 1)
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          (!__props.isEdit)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                innerHTML: item.checklistGroupActions?.replace(/\n/g, '<br>')
                              }, null, 8, _hoisted_29))
                            : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                _createVNode(_component_Textarea, {
                                  ref_for: true,
                                  ref_key: "checklistGroupActionsRef",
                                  ref: checklistGroupActionsRef,
                                  modelValue: item.checklistGroupActions,
                                  "onUpdate:modelValue": ($event: any) => ((item.checklistGroupActions) = $event),
                                  style: `outline-color : #EFF0F1`,
                                  class: _normalizeClass([`${
                      isCallApi.value &&
                      isUpdateActions.value &&
                      idUpdateItem.value === item.checklistGroupId
                        ? 'tw-pr-[45px]'
                        : ''
                    }`, "tw-bg-[#eff0f180] tw-w-full tw-overflow-hidden tw-p-[12px] tw-text-[16px] tw-font-[400] tw-text-[#231F20] tw-border-[#EFF0F1] tw-border-solid tw-border tw-rounded-md"]),
                                  value: item.checklistGroupActions,
                                  rows: "1",
                                  type: "text",
                                  onFocus: 
                      () => {
                        if (item.checklistGroupActions)
                          item.oldChecklistGroupActions =
                            item.checklistGroupActions;
                      }
                    ,
                                  onInput: ($event: any) => (onresizeTextarea(checklistGroupActionsRef.value, index)),
                                  onBlur: 
                      async (e) => {
                        isUpdateActions.value = true;
                        isUpdateName.value = false;
                        isUpdateDescription.value = false;
                        const value = e.target.value.trim();
                        if (
                          item.oldChecklistGroupActions === value ||
                          (item.checklistGroupActions === null && value === '')
                        ) {
                          return;
                        }
                        item.checklistGroupActions = value;
                        const res = await updateChecklistGroup(
                          {
                            checklistGroupId: item.checklistGroupId,
                            actions: value,
                          },
                          item,
                        );
                        item.checklistGroupActions = res
                          ? res.actions
                          : item.oldChecklistGroupActions;
                      }
                    
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "value", "onFocus", "onInput", "onBlur"]),
                                (
                      isCallApi.value &&
                      isUpdateActions.value &&
                      idUpdateItem.value === item.checklistGroupId
                    )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                      _createVNode(_unref(LottieAnimation), {
                                        ref_for: true,
                                        ref: "anim",
                                        "animation-data": _unref(ProgressAnimation),
                                        "auto-play": true,
                                        loop: true
                                      }, null, 8, ["animation-data"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(getComponentUiText)(
                      "app-share-cyber-profile-roadmap-table-importance-header-title-1",
                    )), 1),
                          _createVNode(QualityAssessment, {
                            data: item.checklistGroupBang,
                            type: _unref(QUALITY_ASSESSMENT_TYPE).IMPORTANCE
                          }, null, 8, ["data", "type"])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(getComponentUiText)(
                      "app-share-cyber-profile-roadmap-table-cost-header-title-1",
                    )), 1),
                          _createVNode(QualityAssessment, {
                            data: item.checklistGroupBuck,
                            type: _unref(QUALITY_ASSESSMENT_TYPE).COST
                          }, null, 8, ["data", "type"])
                        ])
                      ])
                    ])
                  ], 2))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (!customTableData.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(getComponentUiText)(
                  "app-share-cyber-profile-quick-wins-empty-list-title-1",
                )), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, _hoisted_43))
      : _createCommentVNode("", true)
  ]))
}
}

})